<template>
    <section class="py-20 pl-14 lg:pl-0 lg:flex lg:justify-end pr-4">
        <div class="lg:w-1/2">
            <div class="border-l border-black px-3 lg:max-w-lg">
                <p>{{ $t('home.aboutText') }}</p>

                <a href="#" class="flex gap-1 items-center mt-20">
                    <router-link :to="{ name: 'about' }">{{ $t('learnMore') }}</router-link>
                    <span class="material-symbols-outlined text-base">arrow_right_alt</span>
                </a>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'OrganismHomeAbout',
}
</script>
